import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { EguardValidationService } from '../../../../core/components/validation/validation.service';
import { EguardConfirmatialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { MatStepper } from '@angular/material';
import { CaseService } from '../../../shared/services/case.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../shared/services/api.service';
import { CommentService } from '../../../shared/services/comment.service';
import { UserService } from '../../../shared/services/user.service';
import { StripePaymentService } from '../../../shared/services/stripePayment.service';
import { FormsService } from '../../../shared/services/forms.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { environment } from '../../../../../environments/environment';
import { NotifyPopupComponent } from '../notify-popup/notify-popup.component';
import { ConfirmationDialogComponent } from '../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { PreSignService } from 'app/main/shared/services/preSign.service';
import { HttpClient } from '@angular/common/http';
import { CheckrService } from '../../../shared/services/checkr.service';
import { HeaderTitleService } from 'app/services/header-title.service';
import { ModeOfPaymentsDialogComponent } from '../dailog/mode-of-payments-dialog/mode-of-payments-dialog.component';
import { OrganizationServices } from 'app/main/shared/services/organization.services';

@Component({
  selector: 'eguard-case-view-form',
  templateUrl: './case-view.component.html',
  styleUrls: ['case-view.component.scss'],
  providers: [
    CaseService,
    CommentService,
    UserService,
    StripePaymentService,
    FormsService,
    LocalUserService
  ]
})
export class EguardCaseViewComponent implements OnInit, OnDestroy {

  // this is how much the user will be charge to submit the form
  // this must be in cents
  // every $1 = 100
  formFee = 0;
  transactionId = null;

  // this is the current index of the json schema
  currentPage = 0;

  // this is what will hold the json schema that will display to the user
  jsonSchema = [];

  // this is dataStorage from jsonSchema
  dataStorage = {};

  // this is for confirm or deny popup
  dialogRef: any;

  // this is the JWT token to verify the user to the backend
  token: string;

  // this is the current users role
  userRole: string;

  // this is what org the user is in
  org: string;

  // current status of the form
  status: string = null;

  // this is the id of the user (sub)
  userId: string;

  // this is what form in format: 2.3
  form: string;
  background_package: string;

  currentPackage: '';

  // this can be null meaning its a new form
  caseId: string;
  parentCase: string;

  // the key is for what part of schema it belongs to then the comment is the comment
  commentData = [];
  commentsLoading = true;

  // this is the form group for the comment section
  commentForm: FormGroup;
  commentId: string;

  // this is the clicked ones
  // this may be removed
  selectedElements: Array<any> = [];

  steppers = null;

  loading = true;

  tempId: string;
  formId: string;

  showComments = false;
  disableSubmit = false;

  // this will just contain the list of names for comment logs
  userNames = [];
  userCount = 0;

  /*
      this can be
      null = nothing shown
      sending = sending
      sent = sent

      this should be set to null anytime the page changes
   */
  messageStatus = null;

  // loading icon
  formActionLoading = false;

  error: string;
  formActionLoadingDeny = false;
  isResubmitForm = false;
  dueFormEmpty = true;

  disableEdit = false;
  user: any;
  isStripeCheckoutCancelled = false;
  // to see json schema form validation
  isSchemaFormValid = true;
  caseNumber: string;
  caseNumberError = false;
  organizations: any = [];
  towns: any = [];

  tempCaseId: any;
  
  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private caseService: CaseService,
    private preSign: PreSignService,
    private http: HttpClient,
    private cognito: CognitoUtil,
    private route: ActivatedRoute,
    private commentService: CommentService,
    private userService: UserService,
    private router: Router,
    private stripeService: StripePaymentService,
    private formsService: FormsService,
    private localUser: LocalUserService,
    private checkrService: CheckrService,
    private headerService: HeaderTitleService,

    private organizationService: OrganizationServices
  ) {
    // these come from the url
    this.form = this.route.snapshot.params['form'];
    this.caseId = this.route.snapshot.params['id'];
    this.parentCase = this.route.snapshot.params['parentCase'];
    this.tempId = this.route.snapshot.params['tempId'];
    this.formId = this.route.snapshot.params['formId'];
    this.formFee = this.route.snapshot.params['formFee'];
    this.userId = this.localUser.getUserId();
    // this.org = this.localUser.getOrganizationId();
    this.userRole = this.localUser.getRole();
    this.background_package = this.localUser.getBackgroundPackage();

    if (this.formId != null) {
      this.commentId = this.formId;
    }
    else {
      this.commentId = this.caseId;
    }
    if(this.caseId) {
      this.caseService.getCaseById('', this.caseId)
      .subscribe(result => {
        this.org = result.summary.organization_id;
      });
    }

    this.getCaseSchema();
  }

  ngOnInit() {
    this.commentForm = new FormGroup({
      comment: new FormControl('')
    });

    if(this.form == 'checkrDetails') {
      let theUser = JSON.parse(localStorage.getItem('userDetails'));
      this.userService.getUserById('', theUser.id).subscribe(res => {
        if (res.length > 0) {
          this.tempCaseId = res[0].id;
        }
      });
    }

    // this removes the submit button.
    // do not remove
    $('.content').on('DOMNodeInserted', function () {
      $('.mat-raised-button.mat-primary').remove();
    });
    if (!this.user) {
      let userDetails = localStorage.getItem('userDetails');
      if (userDetails) {
        this.user = JSON.parse(userDetails);
      }

    }
    setTimeout(() => { this.sendHeaders(); });
  }

  
  sendHeaders(): void {
    if (this.form == '2.3') {
      this.headerService.sendHeader('list_alt', 'Petition')
    }
    if (this.form == '2.8') {
      this.headerService.sendHeader('list_alt', 'Submit 2.8')
    }
    if (this.form == 'checkrDetails') {
      this.headerService.sendHeader('list_alt', 'Background Screening')
    }
  }

  ngOnDestroy() {
    this.snackBar.dismiss();
  }

  // the point of this is to change the form when the page changes.
  goBack(stepper: MatStepper) {
    this.saveFormData();
    
    // this is so you can not fall below 0
    if (this.currentPage !== 0) {
      this.currentPage--;
      stepper.previous();
    }
    this.messageStatus = null;
  }

  // the point of this is to change the form when the page changes.
  goForward(stepper: MatStepper, form?) {
    this.saveFormData();
    // this.jsonSchema[this.getCurrentKey()].data = this.dataStorage[this.getCurrentKey()];
    // this can not go above the max length
    if (this.currentPage !== this.jsonSchema.length) {
      this.currentPage++;
      stepper.next();
    }
    this.messageStatus = null;
  }

  // this saves the form anytime the user changes something
  // on load this gives an error because we are in dev
  // https://github.com/angular/angular/issues/6005
  // it seems it is ignorable
formDataObj:any;
  formChange(event) {
    this.updateStorage(event);
  }

  saveFormData() {
    this.jsonSchema[this.currentPage].data[this.getCurrentKey()] = this.dataStorage[this.getCurrentKey()];
  }

  stepperSelectionChange(event) {
    this.saveFormData();
    this.currentPage = event.selectedIndex;
  }

  submitFinal() {

    this.formActionLoading = true;

    let sendData = {
      form_id: this.form,
      petitionData: this.dataStorage,
      status: 'needs submission'
    };

    switch (this.form) {

      case 'checkrDetails':

        let checkrData = {
          first_name: '',
          middle_name: '',
          last_name: '',
          no_middle_name: false,
          email: '',
          zipcode: '',
          dob: '',
          ssn: '',
          driver_license_number: '',
          driver_license_state: '',
          signature: ''
        }

        let formData

        formData = this.checkrFormData()

        checkrData.first_name = formData.welcome.first_name
        checkrData.middle_name = formData.welcome.middle_name || null
        checkrData.last_name = formData.welcome.last_name
        checkrData.email = formData.welcome.email
        checkrData.zipcode = formData.welcome.zip_code
        checkrData.dob = formData.welcome.DOB
        checkrData.ssn = formData.welcome.SSN
        checkrData.driver_license_number = formData.welcome.driver_license_number
        checkrData.driver_license_state = formData.welcome.driver_license_state
        checkrData.signature = formData.acknowledgement.signature

        this.checkrService.postCheckr(this.userId, checkrData)
          .subscribe(data => {
            this.snackBar.open('Your payment has been processed.', null, {
              extraClasses: ['success-snackbar'],
              duration: 5000
            });

            // this.dialogRef = this.dialog.open(NotifyPopupComponent, {
            //   data: {
            //     title: 'Form Submitted',
            //     message: 'Your payment has been processed.'
            //   },
            //   panelClass: "notifyDialog"
            // });
            // this.dialogRef.afterClosed()
            //   .subscribe(response => {
                let theUser = JSON.parse(localStorage.getItem('userDetails'));
                this.userService.getUserPrefrence(theUser.id)
                  .subscribe(result => {
                    this.userService.getUserById('', theUser.id).subscribe(res => {
                      if (res && res.length > 0) {
                        let caseId = res[0].id;
                        this.stripeService.updateStripePayment(this.transactionId, caseId, {
                          "description": "Background check fees"
                        });
                      }
                    });
                    theUser.background_id = result.background_id || null;
                    theUser.background_package = result.background_package || null;
                    theUser.background_status = result.background_status || null;
                    theUser.background_report_id = result.background_report_id || null;

                    localStorage.setItem('userDetails', JSON.stringify(theUser));
                    this.router.navigate(['/dashboard']);
                  })
              // });
          }, error => {
            this.formActionLoading = false;
            this.snackBar.open('Error loading Form. Try again later.', '', {
              duration: 10000,
            });
          })
        break;

      case '2.8':
        var d = {};
        sendData['status'] = 'NEEDS_UPLOAD_FROM_GUARDIAN';
        for (var k in sendData.petitionData) {
          for (var l in sendData.petitionData[k]) {
            if (l.includes("field") || l.includes("fieldComboBox") || l.includes('fieldCheckBox') || l.includes('Signed')) {
              d[l] = sendData.petitionData[k][l];
            }
          }
        };
        var userData = this.user;
        d["field24"] = userData.first_name + " " + userData.last_name;
        this.formActionLoading = true
        this.caseService.postDueForm(this.caseId, this.formId, d)
          .subscribe(result => {
            this.router.navigate(['dashboard']);
          }, error => {
            this.formActionLoading = false;
            this.error = 'Can not update form 2.8 ';
            this.snackBar.open(this.error, '', {
              duration: 2000,
            });
          });


        break;

      case '2.3':
        var d = {};
        d["guardian"] = {};
        for (var k in sendData.petitionData) {
          for (var l in sendData.petitionData[k]) {
            if (l.includes("guardian")) {
              d["guardian"][l.split("_", 2)[1]] = sendData.petitionData[k][l];
            } else {
              d[l] = sendData.petitionData[k][l];
            }
          }
        };
        d["fieldComboBox4"] = localStorage.getItem('town');
        let orgId = localStorage.getItem('tempOrg');
       
        this.caseService.postNewCase(orgId, this.userId, this.form, d)
        .subscribe(result => {

          localStorage.removeItem('town');
          localStorage.removeItem('tempOrg');

          let caseId = result.id;

          if (this.transactionId != null) {
            this.stripeService.updateStripePayment(this.transactionId, caseId, {
              "description": "Payment for a new petition"
            })
              .subscribe(stripeResult => {
                this.disableSubmit = true;
                this.snackBar.open('Your case has been submitted to the court.', null, {
                  extraClasses: ['success-snackbar'],
                  duration: 5000
                });
                
                // this.dialogRef = this.dialog.open(NotifyPopupComponent, {
                //   data: {
                //     title: 'CASE CREATED',
                //     message: 'Your payment has been processed and your case will be sent to the court.'
                //   },
                //   panelClass: "notifyDialog"
                // });
                // this.dialogRef.afterClosed()
                //   .subscribe(response => {
                  setTimeout(() => {
                    this.router.navigate(['dashboard']);
                  }, 3000);
                  // });
                 
              });
          }
          else {
            this.snackBar.open('Your case has been submitted to the court.', null, {
              extraClasses: ['success-snackbar'],
              duration: 5000
            });
            // this.dialogRef = this.dialog.open(NotifyPopupComponent, {
            //   data: {
            //     title: 'Case Created!',
            //     message: 'Your case has been submitted to the court.'
            //   },
            //   panelClass: "notifyDialog"
            // });
            // this.dialogRef.afterClosed()
            //   .subscribe(response => {
              setTimeout(() => {
                this.router.navigate(['dashboard']);
              }, 3000);
              // });
              
          }

        });
        break;

      default:
        var d = {};
        for (var k in sendData.petitionData) {
          for (var l in sendData.petitionData[k]) {
            if (l.includes("field") || l.includes("fieldComboBox") || l.includes('fieldCheckBox')) {
              d[l] = sendData.petitionData[k][l];
            }
          }
        };
        // d["field24"] =  sendData.petitionData['welcome'].first_name +" "+ sendData.petitionData['welcome'].last_name ;
        this.formActionLoading = true
        this.caseService.postDueForm(this.caseId, this.formId, d)
          .subscribe(result => {
            this.snackBar.open('Attorney of record was submitted successfully.', null, {
              extraClasses: ['success-snackbar'],
              duration: 5000
            });
            
            setTimeout(() => {
              this.router.navigate(['dashboard']);
            }, 3000);
            
          }, error => {
            this.formActionLoading = false;
            this.error = 'Can not update';
            this.snackBar.open(this.error, '', {
              duration: 2000,
            });
          });
        break;

    }
  }

  // this will officially approve the case
  approveCase() {

    switch (this.form) {

      case '2.3':
        let data = {
          status: 'NEEDS_UPLOAD_FROM_PETITIONER',
          case_number: this.caseNumber
        };
        this.caseService.getCaseById('', this.caseId)
        .subscribe(result => {
          let orgId = result.summary.organization_id;
          this.caseService.putCaseNew(orgId, this.caseId, data)
          .subscribe(result => {
            this.postCommentSystem(this.userId + ' has approved the case.');
            //this.dataStorage['stateOfRhodeIsland'].ThreePlaceHolder = this.caseNumber;

            //Need to be removed in future
            // this.dataStorage['guardianshipAndDeemedInappropriate'].Seventy_Eight_PlaceHolder = "";
            // this.dataStorage['guardianshipAndDeemedInappropriate'].Seventy_Nine_PlaceHolder = "";
            // this.dataStorage['guardianshipAndDeemedInappropriate'].Eighty_One_PlaceHolder = "";

            this.caseService.generatePDF(orgId, this.caseId, this.form, this.dataStorage)
              .subscribe(result => {
                this.formActionLoading = false;
                this.router.navigate(['dashboard']);
              });
          });

        let caseComment = {
          user_id: this.localUser.getUserId(),
          organization_id: orgId,
          comment_for_id: this.caseId,
          commented_at: new Date(),
          type: 'PETITION_COMMENT',
          message: 'Case was Accepted.'
        };

        this.commentService.postComment(orgId, caseComment)
          .subscribe(result => {
          });
        });
        break;

      case '2.8':
        let sendData = {
          form_id: this.form,
          petitionData: this.dataStorage,
          status: 'NEEDS_UPLOAD_FROM_GUARDIAN'
        };

        this.caseService.putTwoEight(this.parentCase, this.formId, sendData.status, sendData)
          .subscribe(result => {
            this.postCommentSystem(this.userId + ' has approved the case.');

            this.caseService.postTwoEight(this.parentCase, this.formId, this.dataStorage)
              .subscribe(result => {

                this.dialogRef = this.dialog.open(NotifyPopupComponent, {
                  data: {
                    title: 'Case Approved',
                    message: 'Guardian needs to upload.'
                  }
                });
                this.dialogRef.afterClosed()
                  .subscribe(response => {
                    this.router.navigate(['dashboard']);
                  });

              });

          });
        break;
    }

  }

  // this will officially deny the case
  denyCase() {
    let status = 'ERROR';

    switch (this.userRole) {
      case 'JUDGE':
        status = 'DENIED_BY_JUDGE';
        break;
      case 'CLERK':
        status = 'DENIED_BY_CLERK';
        break;
    }

    switch (this.form) {

      case '2.3':
        let data = {
          status: status
        };

        this.postCommentSystem(this.userId + ' has denied the case.');
        this.caseService.getCaseById('', this.caseId)
        .subscribe(result => {
          let orgId = result.ward.organization_id;
          this.caseService.putCaseNew(orgId, this.caseId, data)
          .subscribe(result => {
            this.formActionLoadingDeny = false;
            this.router.navigate(['dashboard']);
          });
        });
        break;

      case '2.8':
        let sendData = {
          form_id: this.form,
          petitionData: this.dataStorage,
          status: 'NEEDS_UPLOAD_FROM_GUARDIAN'
        };

        this.caseService.putTwoEight(this.parentCase, this.formId, sendData.status, sendData)
          .subscribe(result => {
            this.postCommentSystem(this.userId + ' has denied the case.');
            this.dialogRef = this.dialog.open(NotifyPopupComponent, {
              data: {
                title: 'Case Approved',
                message: 'Guardian needs to upload.'
              },
              panelClass: "notifyDialog"
            });
            this.dialogRef.afterClosed()
              .subscribe(response => {
                this.router.navigate(['dashboard']);
              });
          });
        break;

    }
  }

  // this will activate the pop up
  approve() {
    // if(this.caseNumber == undefined || this.caseNumber == ""){
    //   this.caseNumberError =true;
    //   return "";
    // }
    // this.caseNumberError =false;

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        Case_Check: true,
        userRole: this.userRole
      },
      panelClass: "confirmDetails"
    });
    this.dialogRef.componentInstance.msg = 'You are about to approve this case.'
      ;
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.caseNumber = response;
          this.formActionLoading = true;
          this.approveCase();
        }
      });
  }

  // this will activate the pop up
  deny() {
    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      panelClass: "confirmDetails"

    });
    this.dialogRef.componentInstance.msg = 'You are about to deny this case.'
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.formActionLoadingDeny = true;
          this.denyCase();
        }
      });
  }

  getDataFromSchema() {
    let data = {}

    for (let i = 0; i < this.jsonSchema.length; i++) {
      data = Object.assign(data, this.jsonSchema[i].data);
    }

    return data;

  }

  checkrFormData() {
    let data = {}

    for (let i = 0; i < this.jsonSchema.length; i++) {
      data = Object.assign(data, this.jsonSchema[i].data);
    }
    return data;
  }
  checkrPopulateData() {
    //  for (let i = 0; i < this.jsonSchema.length; i++) {

    // this gets the key from the json schema
    let data = {}
    this.jsonSchema[0].data['welcome'] = {
      first_name: this.user.first_name,         //FirstName
      middle_name: this.user.middle_name,         //MiddleName
      last_name: this.user.last_name,           //LastName
      email: this.user.email,
      DOB: this.user.birth_date,
      zip_code: this.user.zip,
    }


    //Check for the Driver standard and driver pro
    let drivers = ["driver_standard", "driver_pro"];
    if (!drivers.includes(this.background_package)) {
      this.jsonSchema[0].layout[0].items = this.jsonSchema[0].layout[0].items.splice(0, 4);
      delete this.jsonSchema[0].schema.properties.welcome.properties.driver_license_state;
      delete this.jsonSchema[0].schema.properties.welcome.properties.driver_license_number;
    }
    // }
  }

  // the purpose of this is to setup default blank data for the form to bind to.
  addDataToScehma() {

    for (let i = 0; i < this.jsonSchema.length; i++) {

      let key = this.jsonSchema[i].layout[0].key;

      let dataObject = {};
      dataObject[key] = {};
      this.jsonSchema[i]['data'] = dataObject;
      this.dataStorage[key] = {};
    }
    this.populateData();
    if (this.form == 'checkrDetails') {
      this.checkrPopulateData();
    }

  }

  populateData() {

    for (let i = 0; i < this.jsonSchema.length; i++) {

      // this gets the key from the json schema
      let key = this.jsonSchema[i].layout[0].key;
      let data = {}
      let dataObject = {};
      dataObject[key] = data;
      this.jsonSchema[i].data = dataObject;
      if (this.userRole != 'ATTORNEY') {
        if (this.form == '2.3') {

          this.jsonSchema[0].data['petitionerName'] = {
            field4: this.user.first_name,             //FirstName
            field4_2: this.user.middle_name,        //MiddleName
            field4_3: this.user.last_name,          //LastName
            field10: this.user.birth_date,
            Petitioner_address: this.user.address,
            Petitioner_zip: this.user.zip,
            Petitioner_state: this.user.state,
            Petitioner_city: this.user.city,
            Petitioner_phone: this.user.phone_number,
            Petitioner_email: this.user.email
          }
        } else if (this.form == '3.4') {
          this.jsonSchema[0].data['fiduciary'] = {
            field7: this.user.first_name + " " + this.user.middle_name + " " + this.user.last_name,
            field8: this.user.address,
            field11: this.user.zip,
            field10: this.user.state,
            field9: this.user.city,
            field13: this.user.phone_number,
            field12: this.user.email
          }
        }
      } else {
        if (this.form == '9.2') {
          this.jsonSchema[i].data['attorney'] = {
            field7: this.user.first_name + " " + this.user.last_name,
            field10: this.user.address,
            field13: this.user.zip,
            field12: this.user.state,
            field11: this.user.city,
            field9: this.user.law_firm,
            field8: this.user.bar_number,
            field15: this.user.phone_number,
            field14: this.user.email
          }
        } else if (this.form == '2.3') {
          this.jsonSchema[i].data['attorney'] = {
            first_name: this.user.first_name,
            middle_name: this.user.middle_name,
            last_name: this.user.last_name,
            birth_date: this.user.birth_date,
            address: this.user.address,
            zip: this.user.zip,
            state: this.user.state,
            city: this.user.city
          }
        }

      }
    }
  }
  getCaseSchema() {
    this.caseService.getCaseScehma(this.form)
      .subscribe(result => {

        if (result.error) {

          this.snackBar.open('Error loading Form. Try again later.', '', {
            duration: 10000,
          });

          return null;
        }

        this.jsonSchema = result;
        console.log(this.jsonSchema);

        if (this.caseId === undefined && this.tempId === undefined) {
          this.loading = false;
        }

        this.addDataToScehma();

        if (this.caseId !== undefined || this.parentCase !== undefined) {
          this.getCaseData();
        }
        else {
          this.loading = false;
        }
        if (this.userRole === 'GUARDIAN' && this.form === 'checkrDetails') {
          this.getAllPackages()
        } else {
          this.setStripeCost();
        }
      });
  }

  getAllPackages() {
    this.formActionLoading = true
    this.checkrService.getcheckrPackages().subscribe(packages => {
      packages.data.forEach(item => {
        if (item.slug === this.background_package) {
          this.currentPackage = item
          this.formFee = item.price
        }
      }, error => {
        this.formActionLoading = false;
        this.getAllPackages()
      })
      this.formActionLoading = false
    })
  }

  paymentMode() {
    if (this.formFee === 0) {
      this.submitFinal();
      return;
    }
    
    this.formActionLoading = true;
    let selectedCase = { 'id': this.caseId };

    var town;
    for (var k in this.dataStorage) {
      for (var l in this.dataStorage[k]) {
        if(l.includes("fieldComboBox4")) {
          town = this.dataStorage[k][l];
        }
      }
    };
    
    // this.organizationService.getOrganizationDetail(town)
    // .subscribe(result => { 
    //   let orgnzId = result.id;
      const dialogRef = this.dialog.open(ModeOfPaymentsDialogComponent, {
        panelClass: 'modeOfPayments',
        width: '550px',
        data: {
          case: selectedCase,
          temp: this.tempCaseId,
          form: this.form,
          // org: orgnzId,
          form_Id: this.formId,
          type: 'FILE_PETITION',
          formFee: this.formFee
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.isStripeCheckoutCancelled = false;
        this.formActionLoading = false;
        if (result.value == 'true') {
          if(result.txnId) {
            this.transactionId = result.txnId;
            this.submitFinal();
          }
          // this.submitFinal();
        }
      });
    // });

    
  }

  // activateStripe() {
  //   this.formActionLoading = true;
  //   if (this.formFee === 0) {
  //     this.submitFinal();
  //     return;
  //   }

  //   let handler = (<any>window).StripeCheckout.configure({
  //     key: environment.stripeKey,
  //     locale: 'auto',
  //     token: (token: any) => {
  //       this.isStripeCheckoutCancelled = false;
  //       this.stripeService.postStripePayment(this.org, this.userId, token, this.formFee)
  //         .subscribe(result => {
  //           this.transactionId = result.id;
  //           // this submits the case to the backend.
  //           this.submitFinal();
  //         });
  //     }
  //   });

  //   handler.open({
  //     name: 'Court Fee',
  //     description: 'Submission Fee',
  //     amount: this.formFee,
  //     image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
  //     zipCode: true,
  //     closed: () => {
  //       this.formActionLoading = !this.isStripeCheckoutCancelled;
  //     }
  //   });

  // }

  getCaseData() {

    let id = this.caseId;

    if (id === undefined) {
      id = this.parentCase;
    }

    switch (this.userRole) {
      case 'CLERK':
      case 'JUDGE':
        this.disableEdit = true;
        break;
    }

    this.caseService.getCaseById('', id)
      .subscribe(result => {

        let data = '';


        if (this.formId !== undefined) {

          let dueForm = this.getDueFormFromCase(result.due_forms, this.form, this.formId);

          if (dueForm.accepted_date) {
            dueForm.status = "UPLOAD_APPROVED_BY_CLERK";
          } else if (dueForm.rejected_date) {
            dueForm.status = "UPLOAD_DENIED_BY_JUDGE";
          } else if (dueForm.submission_date) {
            dueForm.status = "UPLOAD_FILED_FOR_CLERK";
          } else if (dueForm.generation_date) {
            dueForm.status = "NEEDS_UPLOAD_FROM_GUARDIAN";
          } else {
            dueForm.status = "SUBMIT_DUE_FORM";
          }
          this.status = dueForm.status;

          if (dueForm.petitionData !== null) {
            this.dueFormEmpty = false;
            data = JSON.parse(dueForm.petitionData);
          }

        } else if (this.caseId !== undefined) {
          this.status = result.summary.status;

          this.dueFormEmpty = false;

          // this turns result into json and contains the forms data
          data = JSON.parse(result.petitionData);

          if (data['guardian'] != undefined) {
            data['guardian_email'] = data['guardian'].email;
            data['guardian_address'] = data['guardian'].address;
            data['guardian_phone'] = data['guardian'].phone;
            data['guardian_Name'] = data['guardian'].Name;
          }

        }

        if (data !== '') {
          // this is to bind dy data with here
          // this will bind the petitionData to the current schema
          for (let i = 0; i < this.jsonSchema.length; i++) {

            // this gets the key from the json schema
            let key = this.jsonSchema[i].layout[0].key;

            if (data[key] !== undefined) {
              let dataObject = {};
              dataObject[key] = data[key];
              this.jsonSchema[i].data = dataObject;
            } else {
              let dataObject = {};
              dataObject[key] = data;
              this.jsonSchema[i].data = dataObject;
            }
          }
        }

        this.dataStorage = this.getDataFromSchema();
        this.loading = false;
        this.steppers = $('#formStepper');
        this.getComments();

      });
  }

  getDueFormFromCase(dueForms, form, dueFormId) {
    for (let i = 0; i < dueForms.length; i++) {
      if (dueForms[i].id === dueFormId && dueForms[i].details.id === form) {
        return dueForms[i];
      }
    }
  }

  resubmitCase(caseType) {
    this.isResubmitForm = true;
    if (caseType == 'DUEFORM') {
      this.caseService.putStatusUpdate(this.caseId, this.formId, 'SUBMIT')
        .subscribe(result => {
          this.router.navigate(['dashboard']);
        });
    } else {
      this.isResubmitForm = true;
      let data = {
        status: 'RESUBMITTED_FOR_CLERK'
      };

      this.caseService.getCaseById('', this.caseId)
      .subscribe(result => {
        let orgId = result.ward.organization_id;
        this.caseService.putCaseNew(orgId, this.caseId, data)
        .subscribe(result => {
          this.postCommentSystem(this.userId + ' has resubmitted this form.');
          this.router.navigate(['dashboard']);
        });
      });
    }

  }

  updateStorage(event) {
    // console.log('updateStorage: ',event);
    // console.log('vone: ', event[this.jsonSchema[this.currentPage].layout[0].key]);

    // the purpose of the ternary is to avoid undefined getting into the json schema and dataobject
    // if that happens it can not bind correctly to the forms.
    this.dataStorage[this.jsonSchema[this.currentPage].layout[0].key] =
      event[this.jsonSchema[this.currentPage].layout[0].key] === undefined ? {} : event[this.jsonSchema[this.currentPage].layout[0].key];
  }

  getCurrentKey() {
    return this.jsonSchema[this.currentPage].layout[0].key;
  }

  postComment(comment) {

    let caseComment = {
      id: null,
      user_id: this.userId,
      // organization_id: this.org,
      comment_for_id: this.commentId,
      commented_at: new Date(),
      type: 'PETITION_COMMENT',
      message: comment
    };

    // this.commentService.postComment(this.org, caseComment)
    //   .subscribe( result => {
    //       this.commentForm.controls.comment.setValue('');
    //       this.messageStatus = 'sent';
    //       this.getComments();
    //   });

  }

  postCommentSystem(comment) {

    let caseComment = {
      id: null,
      user_id: null,
      // organization_id: this.org,
      comment_for_id: this.commentId,
      commented_at: new Date(),
      type: 'PETITION_COMMENT',
      message: comment
    };

    // this.commentService.postComment(this.org, caseComment)
    //   .subscribe( result => {
    //     this.getComments();
    //   });

  }

  addComment() {

    let commentMessage = this.commentForm.controls.comment.value;

    if (commentMessage.length > 2) {

      this.messageStatus = 'sending';
      this.postComment(commentMessage);

    } else {
      this.messageStatus = 'error: char';
    }

  }

  formatTime(unix) {
    let date = new Date(unix);
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }

  getComments() {

    this.showComments = true;
    this.commentsLoading = true;
    this.commentData = [];

    this.commentService.getComment('', this.commentId)
      .subscribe(result => {

        result.sort(function (x, y) {
          // this sorts all comments. with the new ones on top.
          return y.commented_at - x.commented_at;
        });

        this.commentData = result;
        this.getUserNames();
        this.messageStatus = null;
      });

  }

  cleanSystemText(msg) {
    let UUID = this.getUUIDFromText(msg);
    return msg.replace(UUID, this.userNames[UUID]);
  }

  getUUIDFromText(msg) {
    let regex = /^[a-zA-Z0-9-]+/;
    return regex.exec(msg)[0];
  }

  setStripeCost() {
    this.formsService.getForms('', this.userRole)
      .subscribe(result => {
        for (let i = 0; i < result.length; i++) {
          if (result[i].id === this.form) {
            this.formFee = result[i].fee;
          }
        }
      });
  }

  getUserNames() {
    this.userNames = [];
    this.userCount = 0;
    let usersUnique = [];

    for (let i = 0; i < this.commentData.length; i++) {

      let userID = this.commentData[i].user_id;

      if (userID === null) {
        userID = this.getUUIDFromText(this.commentData[i].message);
      }

      if (usersUnique.indexOf(userID) === -1) {
        usersUnique.push(userID);
        this.userCount++;
        this.getUserName(userID);
      }

    }

    // this is incase comments are empty and no users need to be loaded
    if (this.userCount === 0) {
      this.commentsLoading = false;
    }
  }

  getUserName(id) {
    this.userService.getUser(id)
      .subscribe(result => {

        this.userNames[id] = result.first_name;

        if (result.last_name !== null) {
          this.userNames[id] += ' ' + result.last_name;
        }

        if (Object.keys(this.userNames).length == this.userCount) {
          this.commentsLoading = false;
        }

      });
  }

  schemaFormValid(event, stepper) {
    this.isSchemaFormValid = !event;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/case-view/case-view.component.ts